import React, { useState } from "react";
import SearchResults from "./SearchResults";
import styled from "styled-components";
import axios from 'axios';
import { Icon } from 'react-icons-kit';
import {ButtonIconContainer} from '../ButtonIconContainer';
import {search} from 'react-icons-kit/icomoon/search';

const SearchContainer = styled.div`
  text-align: left;
  color: black;
`;

const SearchInput = styled.input`
  width: ${(props) => (props.width ? props.width : "300px")};
  vertical-align: top;
`;

export default function SearchBox({
  width,
  remoteDataSource,
  placeholder,
  searchResultTemplate,
  onClickCallback
}) {
  const [results, setResults] = useState(null);
  const [shouldDisplayResults, setShouldDisplayResults] = useState(false);
  const [searchTerm,setSearchTerm] = useState('');

  const onFindClicked = (searchTerm) => {
    if (searchTerm === null || searchTerm === undefined || searchTerm === "") {
      setShouldDisplayResults(false);
    } else {
      fetchResults(searchTerm);
      setShouldDisplayResults(true);
    }
  };

  const onItemClicked = (item) => {
    onClickCallback(item);
    setSearchTerm('')
    setShouldDisplayResults(false);
  }

  const fetchResults = async (searchTerm) => {

    const response = await axios.get(`${remoteDataSource}/${searchTerm}`,{ withCredentials:true })
    .then(res => {
      setResults([res.data.data])
    })
    .catch(err => {
      alert(err)
    })
    // .then(data => {
    //   setResults(results);
    // })
   // setResults([response]);
    // const results = values.filter((item) => item.value === searchTerm);
    
  };

  return (
    <SearchContainer>
      <SearchInput tabIndex="0"
        value = {searchTerm}
        placeholder={placeholder ? placeholder : "Search..."}
        width={width}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <button onClick={() => onFindClicked(searchTerm)} tabIndex="0">
        <ButtonIconContainer color={'#000'}>
          <Icon icon={search}/>
        </ButtonIconContainer>
      </button>
      <SearchResults tabIndex="0"
        visible={shouldDisplayResults}
        results={results}
        template={searchResultTemplate}
        width={width}
        onItemClick={onItemClicked}
      />
    </SearchContainer>
  );
}
